//lib imports
import Router from "next/router";

//style imports
import styles from "src/styles/pages/error.module.scss";

function Error({ statusCode }) {
  return (
    <>
      {statusCode === 404 ? (
        <div
          className={`${styles.helpTopicsSec} ${styles.container} text_center`}
        >
          <h1>404</h1>
          <br />
          <h3>
            The page you were looking for could not be found. Use the search
            above to resolve your queries.
          </h3>
          <br />
          <br />
          <br />
        </div>
      ) : (
        <div
          className={`${styles.helpTopicsSec} ${styles.container} text_center`}
        >
          <h1>OOPS! Something Went Wrong</h1>
          <br />
          <h3>
            {statusCode
              ? `An error ${statusCode} occurred on server. `
              : "An error occurred on client. "}
            Try reloading the page to fix this error if the error persists
            please try after some time.
          </h3>
          <div className={styles.submit_btn}>
            <span onClick={() => Router.reload()}>Try again</span>
          </div>
        </div>
      )}
    </>
  );
}

Error.displayName = "CustomErrorPage";

Error.getInitialProps = ({ res, err }) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  return { statusCode };
};

export default Error;
